<template>
  <div class="auth-split">
    <div class="auth-split__left">
      <div class="auth-split__lang">
        <button
          type="button"
          @click="$emit('lang', 'ru')"
          :class="{ active: locale === 'ru' }"
          class="auth-split__lang-btn"
        >
          RU
        </button>
        <button
          type="button"
          @click="$emit('lang', 'en')"
          :class="{ active: locale === 'en' }"
          class="auth-split__lang-btn"
        >
          EN
        </button>
      </div>
      <div class="auth-split__form-wrap">
        <div class="auth-split__brand">
          <span class="auth-split__logo">GrowBoard</span>
        </div>
        <slot />
      </div>
      <footer class="auth-split__foot">
        <a href="https://www.growboard.ru" target="_blank" rel="noopener noreferrer">{{ $t('auth.layout.footerProduct') }}</a>
      </footer>
    </div>
    <aside class="auth-split__right" aria-hidden="false">
      <div class="auth-split__hero">
        <p class="auth-split__hero-kicker">{{ $t('auth.layout.heroKicker') }}</p>
        <h1 class="auth-split__hero-title">{{ heroTitle }}</h1>
        <p class="auth-split__hero-sub">{{ heroSubtitle }}</p>
        <div class="auth-split__hero-card">
          <div class="auth-split__hero-gradient" />
          <p class="auth-split__hero-quote">{{ $t('auth.layout.heroQuote') }}</p>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'AuthSplitLayout',
  props: {
    heroTitle: { type: String, required: true },
    heroSubtitle: { type: String, required: true },
    locale: { type: String, default: 'ru' },
  },
  emits: ['lang'],
};
</script>

<style scoped>
.auth-split {
  display: flex;
  min-height: 100vh;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', Roboto, sans-serif;
}

.auth-split__left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  position: relative;
  padding: 24px 32px 20px;
  box-sizing: border-box;
}

.auth-split__lang {
  position: absolute;
  top: 20px;
  right: 24px;
  display: flex;
  gap: 8px;
  z-index: 2;
}

.auth-split__lang-btn {
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.auth-split__lang-btn:hover {
  border-color: #cbd5e1;
}

.auth-split__lang-btn.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.auth-split__form-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  padding-top: 48px;
}

.auth-split__brand {
  margin-bottom: 28px;
}

.auth-split__logo {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #111827;
}

.auth-split__foot {
  margin-top: auto;
  padding-top: 24px;
  font-size: 12px;
  text-align: center;
}

.auth-split__foot a {
  color: #9ca3af;
  text-decoration: none;
}

.auth-split__foot a:hover {
  color: #6b7280;
  text-decoration: underline;
}

.auth-split__right {
  flex: 1;
  min-width: 0;
  background: #f2f0eb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  box-sizing: border-box;
}

.auth-split__hero {
  max-width: 480px;
}

.auth-split__hero-kicker {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  margin: 0 0 12px;
}

.auth-split__hero-title {
  margin: 0 0 16px;
  font-size: clamp(32px, 4vw, 44px);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #111827;
}

.auth-split__hero-sub {
  margin: 0 0 32px;
  font-size: 17px;
  line-height: 1.5;
  color: #4b5563;
}

.auth-split__hero-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 220px;
  background: #e8e4dc;
}

.auth-split__hero-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 55%, #f093fb 100%);
  opacity: 0.35;
}

.auth-split__hero-quote {
  position: relative;
  z-index: 1;
  margin: 0;
  padding: 28px 24px;
  font-size: 15px;
  line-height: 1.55;
  color: #1f2937;
  font-weight: 500;
}

@media (max-width: 960px) {
  .auth-split {
    flex-direction: column;
  }

  .auth-split__right {
    padding: 32px 24px 40px;
    order: -1;
  }

  .auth-split__hero-card {
    min-height: 160px;
  }

  .auth-split__hero-title {
    font-size: 28px;
  }

  .auth-split__form-wrap {
    padding-top: 24px;
  }
}
</style>
